import { Descriptions, Icon, Input, Skeleton } from "antd";
import { isEqual } from "lodash";
import React, { Fragment, useState } from "react";
import Ripple from "../../../../common/component/Ripple";
import Span from "../../../../common/component/Span";
import Wrapper from "../../../../common/component/Wrapper";
import { NATIONALITY } from "../../../../../../constants/Define";
import { HeaderComponent, StatusComponent } from "../../../../common/component/Index";
import AntSelect, { AntOption } from "../../../../common/component/AntSelect";
import * as Func from "../../../../../../helpers/functions";
import { useParams } from "react-router-dom";
import Order, { OrderProfiles as OrderProfilesModel } from '../../../../../../models/Order';
import {cloneDeep} from 'lodash'
import Collapse, { Panel } from "../../../../common/component/Collapse";
import './OrderProfiles.less';

const defaultCollapseKey = "customerInfo";

const OrderProfiles = (props) => {
  //! State
  const { t, orderProfiles, loading,resetValidate, validationProfile, validation, permisions, onSave } = props;
  const {id: orderId} = useParams();
  const [orderProfileUpdate, setOrderProfileUpdate] = useState([]);
  //   const { editing, invoiceEditing } = state;
  const [editing, setEditing] = useState(false);
  const [collapseKey, setCollapseKey] = useState('');

  //! Function

  const onChangeEditing = (fieldName,index, value) => {
    const tempArr = orderProfileUpdate.map((el,ind) => {
      if(ind === index) {
        el[fieldName] = value;
        return {
          ...el
        }
      }else{
        return{
          ...el
        }
      }
    });
    setOrderProfileUpdate(tempArr);
  };

  const onClickCancel = () => {
    const orderEditing = cloneDeep(orderProfiles);
    setOrderProfileUpdate(orderEditing);
    resetValidate();
    setEditing(false);
  };

  const onClickEdit = () => {
    const orderEditing = cloneDeep(orderProfiles);
    setOrderProfileUpdate(orderEditing);
    setEditing(!editing);
  };

  const onClickSave = () => {
    const dataUpdate = orderProfileUpdate.map(el => new OrderProfilesModel(el));
    if(validationProfile(dataUpdate[0])){
      onSave(dataUpdate[0],orderId);
      setEditing(false);
    }
  };

  const renderEditingInput = (fieldName, index) => {
    // const { t, invoice } = props;
    // const { editing, invoiceEditing, validation } = state;
    // return <div></div>;
    return editing ? (
      <Wrapper className={!!validation[fieldName] ? "validate-failed" : ""}>
        {/* <Wrapper className={!!validation[fieldName] ? "validate-failed" : ""}> */}
        <Input
          //   value={invoiceEditing[fieldName]}
          value={orderProfileUpdate[index][fieldName]}
          placeholder={t(`item.order.${fieldName}`)}
          onChange={(e) => onChangeEditing(fieldName,index, e.target.value)}
        />
        {renderErrorMessage(validation[fieldName])}
      </Wrapper>
    ) : (
      orderProfiles[index][fieldName]
    );
  };

  const renderSelecting = (fieldName, index, options) => {
    return editing ? (
      <Wrapper className={!!validation[fieldName] ? "validate-failed" : ""}>
        <AntSelect
          className="select-enum"
          showArrow
          showSearch
          placeholder={Func.capitalizeFirstLetter(
            (
              t("placeHolderForm.select") +
              " " +
              t(`item.order.${fieldName}`)
            ).toLowerCase()
          )}
          value={orderProfileUpdate[index][fieldName]}
          onChange={(e) => onChangeEditing(fieldName,index, e)}
          style={{ width: "100%" }}
          // filterOption={ this.selectFilterSearch }
        >
          {options.map((item) => (
            <AntOption key={item.key} value={item.key}>
              {item.value}
            </AntOption>
          ))}
        </AntSelect>
        {renderErrorMessage(validation[fieldName])}
      </Wrapper>
    ) : (
      orderProfiles[index][fieldName]
    );
  };

  const renderErrorMessage = (error) => {
    return (
      error &&
      error.messageError && (
        <Wrapper className="error-message">
          <Span>{error.messageError}</Span>
        </Wrapper>
      )
    );
  };
  const renderRequiredLabel = (label) => {
    const editing = false;
    // const { editing = false } = this.state;
    return editing ? (
      <Fragment>
        {label}
        <Span style={{ color: "red" }}>{"*"}</Span>
      </Fragment>
    ) : (
      label
    );
  };

  const onToggleCollapse = () => {
    if (collapseKey) {
      // close
      setCollapseKey();
    } else {
      // open
      setCollapseKey(defaultCollapseKey);
    }
  };

  //! Render
  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
      className='my-2'
    >
      <Panel
        className="py-1"
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={<h3 className={`ml-0`} style={{color: '#676a6c'}}>{t("item.order.orderProfiles.title")}</h3>}
            className="col-md-12"
            style={{
              userSelect: "none",
              padding: 0,
            }}
          />
        }
      >
        <Wrapper className="order-info-section col-md-12 px-0">
          <Wrapper className={`row mt-2 order-profile`}>
            {!loading ? (
              (props.orderProfiles || []).map((e, i) => {
                return (
                  <Descriptions
                    title={
                      <span className="my-1" style={{color: '#676a6c'}}>
                        {t("item.order.orderProfiles.member", { number: i + 1 })}
                      </span>
                    }
                    bordered
                    className="white-bg w100-percent"
                    column={2}
                  >
                    <Descriptions.Item
                      label={renderRequiredLabel(
                        t("item.order.orderProfiles.firstName")
                      )}
                    >
                      {renderEditingInput("firstName", i)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={renderRequiredLabel(
                        t("item.order.orderProfiles.lastName")
                      )}
                    >
                      {renderEditingInput("lastName", i)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={renderRequiredLabel(
                        t("item.order.orderProfiles.phoneNumber")
                      )}
                    >
                      {renderEditingInput("phoneNumber", i)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={renderRequiredLabel(
                        t("item.order.orderProfiles.email")
                      )}
                    >
                      {renderEditingInput("email", i)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={renderRequiredLabel(
                        t("item.order.orderProfiles.nationality")
                      )}
                    >
                      {/* {renderEditingInput("nationality", i)} */}
                      {renderSelecting("nationality", i, NATIONALITY)}
                    </Descriptions.Item>
                  </Descriptions>
                );
              })
            ) : (
              <Skeleton active paragraph={{ row: 7 }} />
            )}
          </Wrapper>
          {permisions && permisions.allowUpdate && (
            <Wrapper
              className={`editing-buttons ${editing ? "editing" : ""}`}
              onClick={onChangeEditing}
            >
              <Ripple
                waitForEffect={true}
                className={`btn-edit p-1 mr-1`}
                onClick={!editing ? onClickEdit : onClickCancel}
              >
                <Icon type={editing ? "close" : "edit"} />{" "}
                {editing ? t(`action.cancel`) : t(`action.edit`)}
              </Ripple>
              {editing && (
                <Ripple
                  waitForEffect={true}
                  className={`btn-save p-1`}
                  disabled={loading || isEqual(orderProfileUpdate, orderProfiles)}
                  // disabled={loading}
                  onClick={onClickSave}
                >
                  <Icon type="save" /> {t(`action.save`)}
                </Ripple>
              )}
            </Wrapper>
          )}
        </Wrapper>
      </Panel>
    </Collapse>
  );
};

export default OrderProfiles;
